var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_280_2",
    "data-name": "Component 280 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16831",
    "data-name": "Group 16831",
    transform: "translate(-4180.725 -2881.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15173",
    "data-name": "Path 15173",
    d: "M14.651,3.451A3.323,3.323,0,1,1,11.328.128a3.323,3.323,0,0,1,3.323,3.323",
    transform: "translate(4185.151 2890.307)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15174",
    "data-name": "Path 15174",
    d: "M.221,28.4a5.754,5.754,0,1,1,11.508,0Z",
    transform: "translate(4190.504 2875.823)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6910",
    "data-name": "Rectangle 6910",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.01be4c688b9dbc9e8395550a7ee42b5f.svg";
export { ForwardRef as ReactComponent };